"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var type_narrowing_1 = require("@shared/utils/type-narrowing");
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
var UnsupportedWidgetError = /** @class */ (function (_super) {
    __extends(UnsupportedWidgetError, _super);
    function UnsupportedWidgetError(message) {
        var _this = _super.call(this, message) || this;
        _this.name = _this.constructor.name;
        _this.message = message;
        _this.unsupportedWidget = true;
        return _this;
    }
    return UnsupportedWidgetError;
}(Error));
(function (module) {
    'use strict';
    module.factory('prResponseCount', [
        '$q',
        'prActiveReport',
        'pr.globalOptionsService',
        'pr.timezoneUtil',
        'prSavedFiltersService',
        'pr.dataRequestService',
        'prOverrideTrigger',
        'pr.OVERRIDE_EVENTS',
        'pr.filters',
        'prFilterUtils',
        function ($q, activeReport, globalOptions, timezoneUtil, SavedFilters, dataRequestService, triggerOverrides, OVERRIDE_EVENTS, filterService, filterUtils) {
            function getTotalResponseCount(filters, fetchFilterOptions) {
                // all sources are listed under the 'surveyId' property,
                // including non-survey sources. It is possible this could container duplicates.
                var allSources = activeReport.getMetadata('surveyId');
                var mainFieldsetId = triggerOverrides({
                    event: OVERRIDE_EVENTS.SINGLE_FIELDSET,
                    sync: true
                });
                if (mainFieldsetId) {
                    allSources = [mainFieldsetId];
                }
                var nonDuplicatedSources = lodash_1.default.uniq(allSources);
                var promises = lodash_1.default.map(nonDuplicatedSources, function (sourceId) {
                    return getResponseCount(sourceId, (filters || {})[sourceId] || {}, null, fetchFilterOptions);
                });
                return $q.all(promises).then(function (countList) {
                    return lodash_1.default.sum(countList);
                });
            }
            function getResponseCount(sourceId, filters, extraOptions, fetchFilterOptions) {
                return _fetchResponseCount(sourceId, filters, extraOptions, fetchFilterOptions).catch(function (error) {
                    console.error('Could not fetch response count', error);
                    return 0;
                });
            }
            /**
             * Retrieves the number of responses for the fields in the data config.
             * Always uses cached data.
             */
            function _fetchResponseCount(sourceId, filters, extraOptions, fetchFilterOptions) {
                if (!sourceId) {
                    return $q.reject(new UnsupportedWidgetError('Missing sourceId required to fetch response count'));
                }
                var sourceFilters = filters || {};
                sourceFilters = addTimezoneOffsetToFilters(sourceFilters);
                var newFilterDefP;
                if (sourceFilters.filterId
                    && !lodash_1.default.get(fetchFilterOptions, 'skipFetchingFilters')) {
                    // Saved filters. Fetch the latest def and req for count
                    newFilterDefP = new SavedFilters(sourceId)
                        .getUpdatedDefinition(sourceFilters)
                        .then(function (updatedFilters) {
                        filterUtils.fixFilters(updatedFilters);
                        return updatedFilters;
                    });
                }
                else {
                    newFilterDefP = $q.when(sourceFilters);
                }
                return newFilterDefP
                    .then(function (updatedFilters) {
                    extraOptions = lodash_1.default.assign(extraOptions, {
                        sourceId: sourceId,
                        useCache: true
                    });
                    var options = {
                        sourceId: sourceId,
                        metrics: [{
                                type: 'count',
                                fieldId: extraOptions.fieldId || '_recordId'
                            }],
                        filters: updatedFilters
                    };
                    return dataRequestService.post(options, 'aggregate', extraOptions).then(function (res) {
                        var count = res.data.data[0].value;
                        // @todo - always return request options and let the caller
                        // decide whether to use the options
                        if (extraOptions.returnRequestOptions) {
                            return {
                                count: count,
                                requestOptions: options
                            };
                        }
                        return count;
                    });
                });
            }
            /**
             * Retrieves the number of responses for the fields in the data config
             */
            function getWidgetResponseCount(widgetId, dataConfig, options) {
                if (options === void 0) { options = {}; }
                if (dataConfig.type === 'pr-geometry-component') {
                    return getWidgetResponseCountForSource(dataConfig.sourceId, dataConfig, widgetId, __assign({ fieldId: lodash_1.default.get(dataConfig, 'metrics.0.fieldId') }, options));
                }
                if (type_narrowing_1.hasProperty(dataConfig, 'metrics')) {
                    var sourceIds = lodash_1.default.map(dataConfig.metrics, 'sourceId');
                    sourceIds = lodash_1.default.uniq(lodash_1.default.compact(sourceIds));
                    var promises = lodash_1.default.map(sourceIds, function (sourceId) {
                        return getWidgetResponseCountForSource(sourceId, dataConfig, widgetId, options);
                    });
                    return $q.all(promises).then(sumResponseCounts);
                }
                return getWidgetResponseCountForSource(dataConfig.sourceId, dataConfig, widgetId, options);
            }
            /**
             * Retrieves the number of responses to the given sourceId and fieldId(s)
             */
            function getWidgetResponseCountForSource(sourceId, dataConfig, widgetId, options) {
                return filterService.prepRequestFiltersAsync(dataConfig.filters, sourceId).then(function (filters) {
                    var isPresentFilter = filterService.getIsPresentFilter(sourceId, dataConfig);
                    filters.children.push(isPresentFilter);
                    return filters;
                }).then(function (filters) {
                    return _fetchResponseCount(sourceId, filters, __assign({ widgetId: widgetId }, options));
                });
            }
            /**
             * Appends the proper timezone offset to filters
             */
            function addTimezoneOffsetToFilters(filters) {
                if (lodash_1.default.isEmpty(filters)) {
                    return {};
                }
                if (type_narrowing_1.hasProperty(filters, 'children') && !lodash_1.default.isEmpty(filters.children)) {
                    for (var _i = 0, _a = filters.children; _i < _a.length; _i++) {
                        var child = _a[_i];
                        addTimezoneOffsetToFilters(child);
                    }
                    return filters;
                }
                if (type_narrowing_1.hasProperty(filters, 'filter') && 'dateRange' in filters.filter) {
                    var timezone = globalOptions.getTimezone();
                    var timeZoneOffset = timezoneUtil.getTimezoneOffset(timezone);
                    filters.filter.dateRange.timeZoneOffset = timeZoneOffset;
                }
                return filters;
            }
            /**
             * Sums up the response counts from multiple requests
             */
            function sumResponseCounts(responseCountData) {
                if (lodash_1.default.isEmpty(responseCountData)) {
                    return 0;
                }
                var firstItem = responseCountData[0];
                if (lodash_1.default.isNumber(firstItem)) {
                    return lodash_1.default.sum(responseCountData);
                }
                return lodash_1.default.reduce(responseCountData, function (result, value) {
                    result.count += value.count;
                    result.requestOptionsArray.push(value.requestOptions);
                    return result;
                }, {
                    count: 0,
                    requestOptionsArray: []
                });
            }
            return {
                getTotalResponseCount: getTotalResponseCount,
                getResponseCount: getResponseCount,
                getWidgetResponseCount: getWidgetResponseCount
            };
        }
    ]);
})(angular_1.module('qualtrics.pr'));
